"use client";

import rightImg from "@/images/about-hero-right.png";
import React, { FC } from "react";
// import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import SectionHero from "./SectionHero";
import BgGlassmorphism from "@/components/BgGlassmorphism";
import BackgroundSection from "@/components/BackgroundSection";
import SectionClientSay from "@/components/SectionClientSay";
import SectionSubscribe2 from "@/components/SectionSubscribe2";
import { useTranslation } from 'react-i18next';

export interface PageAboutProps {}

const PageAbout: FC<PageAboutProps> = ({}) => {
  const { t } = useTranslation("guydeez");
  
  return (
    <div className={`nc-PageAbout overflow-hidden relative`}>
      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg={rightImg}
          heading={t('about_us_title')}
          btnText=""
          subHeading={t('about_us_desc')}
        />

        {/* <SectionFounder /> */}
        {/*<div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div>*/}

        <SectionStatistic />

        <SectionSubscribe2 />
      </div>
    </div>
  );
};

export default PageAbout;
